import { Grid, Typography, Box, Stack, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { useForm } from "../../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { formatText } from "../../../../common/helpers";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    },
    referencedCustomer: {
      position: "relative",
      width: "100%",
      padding: theme.spacing(1.5),
      borderRadius: theme.spacing(1),
      background: "#EFF6FF",
      border: `1px solid #BEDBFF`,
      minHeight: "100%",
      userSelect: "none",
      cursor: "default",
      color: "#1C5DBD"
    }
  })
);

export default function ContactSection() {
  const { classes } = useStyles();
  const {
    form,
    contactPerson,
    setContactPerson,
    contactPhoneNumber,
    setContactPhoneNumber,
    customerName,
    setCustomerName,
    customerEmail,
    setCustomerEmail,
    locked
  } = useForm();
  const { t } = useTranslation();

  const { customer } = form;
  const isReferenced = !!customer;

  return (
    <Stack className={classes.root} spacing={1}>

      <Typography variant="h6">
        {t("advancedForm:contactSection:title")}
      </Typography>

      <Box>
        <Grid container spacing={1} alignItems="space-between">

          {!!isReferenced ? (
            <>
              <Grid item xs={12}>
                <ReferencedCustomer customer={customer} />
              </Grid>

              <Grid item xs={12} lg={6}>
                <FormControl fullWidth size="small" variant="filled">
                  <InputLabel>{t("advancedForm:contactSection:contactPerson")}</InputLabel>
                  <Select
                    disabled={locked}
                    onChange={(ev) => {
                      const id = ev.target.value;
                      setContactPerson(id);

                      if (!!id) {
                        let contact = customer?.contactPersons?.find(c => c.id === id);
                        setCustomerName(t => contact?.name || t);
                        setCustomerEmail(t => contact?.email || t);
                        setContactPhoneNumber(t => contact?.phoneNumber || t);
                      }
                    }}
                    value={contactPerson || ""}
                  >
                    <MenuItem value="">{t("advancedForm:contactSection:noContactPerson")}</MenuItem>

                    {customer?.contactPersons?.map((c, key) => <MenuItem value={c.id} key={key}>{c.name}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>

            </>
          ) : null}

          <Grid item xs={12} lg={!!isReferenced ? 6 : 12}>
            <TextField
              label={t("advancedForm:contactSection:name")}
              variant="filled"
              value={customerName}
              onChange={ev => setCustomerName(ev.target.value)}
              fullWidth
              required
              size="small"
              disabled={locked}
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <TextField
              label={t("advancedForm:contactSection:phoneNumber")}
              variant="filled"
              value={contactPhoneNumber}
              onChange={ev => setContactPhoneNumber(ev.target.value)}
              fullWidth
              size="small"
              disabled={locked}
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <TextField
              label={t("advancedForm:contactSection:email")}
              variant="filled"
              value={customerEmail}
              onChange={ev => setCustomerEmail(ev.target.value)}
              fullWidth
              required
              size="small"
              disabled={locked}
            />
          </Grid>

        </Grid>

      </Box>

    </Stack >
  );
}


function ReferencedCustomer(props) {
  const { customer } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();


  return (
    <Box className={classes.referencedCustomer}>
      <Typography variant="body2">{customer.name}</Typography>
      <Typography variant="caption">{formatText(" ", t("advancedForm:contactSection:customerNumber"), customer.customerNumber, "•", customer?.billing?.email || customer.email)}</Typography>
    </Box>
  );
}


